<template>
  <div id="vanber">
    <div class="container">
      <div class="mb20">
        <el-steps :active="active" simple>
          <el-step title="账号注册" icon="el-icon-edit"></el-step>
          <el-step title="补充信息" icon="el-icon-edit-outline"></el-step>
          <el-step title="确认信息" icon="el-icon-tickets"></el-step>
          <el-step title="注册成功" icon="el-icon-circle-check"></el-step>
        </el-steps>
        <!-- <el-button style="margin-top: 12px;" @click="next">下一步</el-button> -->
      </div>
      <RegisterFirst v-if="active == 0" @changeActive="changeActive" />
      <RegisterSec v-if="active == 1" @changeActive="changeActive" />
      <RegisterThird v-if="active == 2" @changeActive="changeActive" @reduceActive="reduceActive" />
      <RegisterLast v-if="active == 3" />
    </div>
  </div>
</template>

<script>
  import RegisterFirst from "@/components/register/RegisterFirst.vue"; //账号注册
  import RegisterSec from "@/components/register/RegisterSec.vue"; // 企业信息
  import RegisterThird from "@/components/register/RegisterThird.vue"; // 营业执照
  import RegisterLast from "@/components/register/RegisterLast.vue"; //注册成功
  
  export default {
    data () {
      return {
        active: Number(localStorage.getItem("regActive"))
        // active: 2,
      };
    },
    components: {
      RegisterFirst,
      RegisterSec,
      RegisterThird,
      RegisterLast
    },
    methods: {
      changeActive () {
        this.active++;
      },
      reduceActive () {
        this.active--;
      }
    }
  };
</script>

<style scoped lang="scss">
  #vanber {
    width: 100%;
    height: 100%;
    background: #fafafa;
    // background: url(../assets/img/register_bg.png) no-repeat center center;
  }
  .container {
    position: relative;
    margin: 0 auto;
    width: 100%;
    max-width: 960px;
    padding-top: 20px;
  }
  .el-steps--simple {
    background: #e4e7ed;
  }
</style>